/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_MetascoreInputs */

const id_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const ms_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const da_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const de_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const en_us2_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const es_es2_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 de Metascore`)
};

const es_mx2_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 de Metascore`)
};

const fil_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const fr_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const it_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const hu_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const nl_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const no_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const pl_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const pt_br2_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metapontuação`)
};

const pt_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const ro_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const fi_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const sv_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const vi_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const tr_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const cs_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const bg_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const ru_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const uk_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 бали Metascore`)
};

const ar_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const hi_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

const th_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 คะแนน Metascore`)
};

const ja_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metascore 82`)
};

const zh_cn2_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82分`)
};

const zh_hant1_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82分`)
};

const ko_misc_posts_metascore = /** @type {(inputs: Misc_Posts_MetascoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`82 Metascore`)
};

/**
* | output |
* | --- |
* | "82 Metascore" |
*
* @param {Misc_Posts_MetascoreInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_metascore = /** @type {((inputs?: Misc_Posts_MetascoreInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_MetascoreInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_metascore(inputs)
	if (locale === "ms") return ms_misc_posts_metascore(inputs)
	if (locale === "da") return da_misc_posts_metascore(inputs)
	if (locale === "de") return de_misc_posts_metascore(inputs)
	if (locale === "en-US") return en_us2_misc_posts_metascore(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_metascore(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_metascore(inputs)
	if (locale === "fil") return fil_misc_posts_metascore(inputs)
	if (locale === "fr") return fr_misc_posts_metascore(inputs)
	if (locale === "it") return it_misc_posts_metascore(inputs)
	if (locale === "hu") return hu_misc_posts_metascore(inputs)
	if (locale === "nl") return nl_misc_posts_metascore(inputs)
	if (locale === "no") return no_misc_posts_metascore(inputs)
	if (locale === "pl") return pl_misc_posts_metascore(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_metascore(inputs)
	if (locale === "pt") return pt_misc_posts_metascore(inputs)
	if (locale === "ro") return ro_misc_posts_metascore(inputs)
	if (locale === "fi") return fi_misc_posts_metascore(inputs)
	if (locale === "sv") return sv_misc_posts_metascore(inputs)
	if (locale === "vi") return vi_misc_posts_metascore(inputs)
	if (locale === "tr") return tr_misc_posts_metascore(inputs)
	if (locale === "cs") return cs_misc_posts_metascore(inputs)
	if (locale === "bg") return bg_misc_posts_metascore(inputs)
	if (locale === "ru") return ru_misc_posts_metascore(inputs)
	if (locale === "uk") return uk_misc_posts_metascore(inputs)
	if (locale === "ar") return ar_misc_posts_metascore(inputs)
	if (locale === "hi") return hi_misc_posts_metascore(inputs)
	if (locale === "th") return th_misc_posts_metascore(inputs)
	if (locale === "ja") return ja_misc_posts_metascore(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_metascore(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_metascore(inputs)
	return ko_misc_posts_metascore(inputs)
});
export { misc_posts_metascore as "misc.posts.metascore" }